const styles = () => ({
  logo: {
    width: '130px',
    height: '42px',
    transition: '0.3s',
  },
});

export default styles;
